import * as t from '@/types'
import Routes from '@/routes'

const variables: t.Variable[] = [
  {
    name: 'Rent / Mortgage',
    type: t.VariableType.single,
    description: 'The money you pay each month to keep a roof over your head.',
    variable: 'Rent_Mortgage_Amt',
    frequency: 'Rent_Mortgage_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Utilities (Gas, Electric, Oil)',
    type: t.VariableType.single,
    description: 'The cost of providing electricity and heating in your home.',
    variable: 'Utilities_Amt',
    frequency: 'Utilities_Freq',
    placeholder: '0.00'
  },
  { name: 'TV & Broadband Packages:',
    type: t.VariableType.single,
    description: 'Broadband and TV bundles, including any streaming services e.g. Netflix.',
    variable: 'TV_Broadband_Amt',
    frequency: 'TV_Broadband_Freq',
    placeholder: '0.00'
  },
  {
    name: 'TV Licence',
    type: t.VariableType.single,
    description: 'The Licence fee is €160 per annum if you have a TV.',
    variable: 'TV_Licence_Amt',
    frequency: 'TV_Licence_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Family Pet',
    type: t.VariableType.single,
    description: 'This figure should reflect cost of food, vets, accessories etc.',
    variable: 'Family_Pet_Amt',
    frequency: 'Family_Pet_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Household Purchases',
    type: t.VariableType.single,
    description: 'Consider the things you buy to keep your house looking nice, from paint to picture frames and vases etc.',
    variable: 'House_Purchases_Amt',
    frequency: 'House_Purchases_Freq',
    placeholder: '0.00'
  },
]

const name = 'Household'
const title = 'Your Household Expenses'
// tslint:disable-next-line
const description = "Now that you have a clear understanding of your overall income, lets look at your expenditure side if things. The next few screens will ask you about how you spend your money. Lets start with some of the key household expenditures you have… "
const outro = ''
const link = Routes.step2

const stepDefinition: t.StepDefinition = {
  index: 2,
  name,
  title,
  description,
  variables,
  outro,
  link,
}

export default stepDefinition
